import moment from 'moment/moment';
import ArrowRight from '@/images/icons/ArrowRight';
import Tooltip from '@/components/Tooltip';
import React from 'react';
import { ROUTES } from '@/config/routes';
import { Link } from 'react-router-dom';
import { isActiveSubscription } from '@/utils/utils';

const SubscriptionStatus = ({ subscription }) => {
	if (subscription) {
		const stripeStatus = subscription?.stripeSubscription?.status;
		const canceledAt = subscription?.stripeSubscription?.canceled_at;
		const trialEnd = subscription?.stripeSubscription?.trial_end;
		const currentPeriodEnd = subscription?.stripeSubscription?.current_period_end;

		let title, description, content;

		switch (stripeStatus) {
			case 'trialing':
				title = subscription?.stripeSubscription?.cancel_at_period_end ? "Will be canceled on" : "Trial is valid until";
				content = moment(trialEnd * 1000).format("LL");
				break;
			case 'active':
				title = subscription?.stripeSubscription?.cancel_at_period_end ? "Will be canceled on" : "Next payment";
				content = moment(currentPeriodEnd * 1000).format("LL");
				break;
		}

		return (
			<>
				<div className="w-full md:w-auto border-t border-t-[#E8E8E8] md:border-t-0 pt-4 md:pt-0 md:ml-auto mt-6 md:mt-2 flex flex-row gap-2.5 text-[13px]/[1.1] md:text-[14px]/[1.3]">
					<div className="text-[#A5A5A5] font-medium">{title}</div>
					<div>
						<span className="font-semibold">{content}</span>
						{description && (
							<Tooltip className="inline-block ml-1 md:ml-1.5 -top-px" size="lg" bg="dark">
								<div className="text-[13px]/[1.4]">
									{description}
								</div>
							</Tooltip>
						)}
					</div>
				</div>
				{isActiveSubscription(subscription) && (
					<Link to={ROUTES.getSubscriptionRoutes().manageSubscription_changePlan} className="btn-secondary min-w-[60px] w-full md:w-auto h-10 py-1.5 px-3 mt-6 md:hidden">Change plan</Link>
				)}
			</>
		);
	}

	return null;
};

export default SubscriptionStatus;
